/** A practical canvas roll with Hetta's grafting knife, pruning saw and whetstone.
 * The tools are recovered quest material; the icon grants no tool interaction. */
export function forestToolRoll(size = 32): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 40 40">
    <path d="M7 18L10 7L15 8L15 26L11 31Z" fill="#76593a" stroke="#3b3729" stroke-width="1"/>
    <path data-part="grafting-knife" d="M11 8Q11 3 16 2L15 10Z" fill="#a3ada4"/>
    <path d="M21 28L20 5L25 4L27 24Z" fill="#78897c" stroke="#354d43" stroke-width="1"/>
    <path d="M21 6L23 8L21 10L24 12L22 14L25 16L23 18L26 20" fill="none" stroke="#c2c8ac" stroke-width=".8"/>
    <path data-part="whetstone" d="M28 28L28 12L33 10L35 13L35 29Z" fill="#929582" stroke="#4d5748" stroke-width=".8"/>
    <path d="M29 13L32 12L33 25" fill="none" stroke="#c4c5ad" stroke-width=".8"/>
    <path data-part="canvas-tool-roll" d="M4 18Q20 22 36 18L35 34Q20 39 5 34Z" fill="#728260" stroke="#344d3c" stroke-width="1.2"/>
    <path d="M6 21L7 32M13 22L14 35M22 22V36M30 21L29 35" stroke="#a5ad82" stroke-width=".9"/>
    <path d="M4 26Q20 29 36 25L36 29Q20 33 4 30Z" fill="#6a4d33"/>
    <rect x="17" y="26" width="7" height="6" rx="1" fill="#c2a36a"/><rect x="19" y="28" width="3" height="2" fill="#5b4932"/>
  </svg>`;
}
